import { THEME } from '@common/constants/theme.constant';
import React from 'react';
import { css } from 'twin.macro';
import { IFieldV2Props } from './field-v2.component';

export interface IFieldSubTextV2Props {
    subText?: IFieldV2Props['subText'];
    className?: string;
}

export const FieldSubTextV2 = ({ subText, className }: IFieldSubTextV2Props): JSX.Element | null => {
    return (
        <div css={styles.root} className={className}>
            {subText}
        </div>
    );
};
const styles = {
    root: css`
        line-height: 21px;
        text-align: left;
        font-size: ${THEME.SMALL_FONT_SIZE};
        font-weight: 300;
        color: ${THEME.TEXT_BLACK};
        max-width: 100%;
    `,
};
